/**
 * @prop --wf-payment-methods-title-color: The color of the box title, default (--mdc-theme-accent).
 * @prop --wf-payment-methods-title-font-size: The font size of the title.
 * @prop --wf-payment-methods-title-font-weight: The font weight of the title.
 * @prop --wf-payment-methods-title-font-size-large: The font weight of the title in medium and large viewports.
 * @prop --wf-payment-methods-box-background-color: The background color of the contact boxes.
 */

:host {
    display: block;
    padding: 16px 0;
}

.title {
    line-height: 1.71;
    margin-bottom: 8px;
    color: var(--wf-payment-methods-title-color, var(--mdc-theme-accent));
    font-size: var(--wf-payment-methods-title-font-size, 0.875rem);
    font-weight: var(--wf-payment-methods-title-font-weight, bold);
}

.images {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: min-content;
    gap: 8px;
}

@media screen and (min-width: 768px) {
    :host {
        padding: 16px 0;
    }

    .title {
        font-size: var(--wf-payment-methods-title-font-size-large, 1rem);
    }
}
